import React, {useEffect} from 'react';
import './styles.scss';
import {RadiusDropdownProps} from "./props";
import {RadiusDropdownLayout} from "./RadiusDropdownLayout";

function RadiusDropdown(props: RadiusDropdownProps) {
  const {options, onChangeRadius, defaultText} = props;
  const [selectedOption, setSelectedOption] = React.useState(defaultText);
  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const handleOptionSelect = (index: number) => {
    setSelectedIndex(index);
    onChangeRadius?.(index, options[index]);
  };
  useEffect(() => {
    const index = options.indexOf(defaultText);
    if (index === -1) {
      setSelectedOption(defaultText);
      return;
    }
    setSelectedIndex(index);
  }, [defaultText, options]);
  useEffect(() => {
    setSelectedOption(options[selectedIndex]);
  }, [selectedIndex, options]);
  return (
    <RadiusDropdownLayout
      options={options}
      selectedOption={selectedOption}
      selectedIndex={selectedIndex}
      label={props.label}
      handleOptionSelect={handleOptionSelect}
    />
  );
}

export default React.memo(RadiusDropdown)
